<app-error-handler alignment="center" displayAs="widget">
  <div class="d-flex justify-content-around contacts-option tabs-content">
    <span id="widgetContractCreateButton" (click)="(bPageLoaded) ? recordDialog() : ''" class="span-links">
      <fa-icon [icon]="['fas', 'plus-circle']" class="text-success mr-1"></fa-icon>
      {{ 'create_contract' | translate }}
    </span>
  </div>
  <div>
    <div class="sites-body">
      <div class="container" style="max-width: 40vw;">
        <div class="row pt-2 pb-2">
          <div class="col-sm-6 pt-1">
            <span class="module-title">
              <fa-icon [icon]="['fa', 'map-marker-alt']" aria-hidden="true"></fa-icon>
              &nbsp;
              {{ 'contracts' | translate }}
            </span>
          </div>
          <div class="col-sm-6 pr-2">
            <nav class="pagination-section" class="float-right">
              <ul class="pagination">
                <refresh-pagination-btn id="widgetSitesRefreshButton" (refresh)="fetchList()" [isDisabled]="bLoading"></refresh-pagination-btn>
                <li [ngClass]="(listingService.strFirstValue != listingService.strCurrentValue && listingService.strCurrentValue != '') ? 'active' : 'disabled'" class="page-item">
                  <a id="widgetSitesPreviousButton" class="page-link" aria-label="first" (click)="fetchList('prev')">
                    <fa-icon [icon]="['far', 'chevron-left']" aria-hidden="true"></fa-icon>
                  </a>
                </li>
                <li [ngClass]="(listingService.strNextValue != '') ? 'active' : 'disabled'" class="page-item">
                  <a id="widgetSitesNextButton" class="page-link" aria-label="first" (click)="fetchList('next')">
                    <fa-icon [icon]="['far', 'chevron-right']" aria-hidden="true"></fa-icon>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <div *ngIf="arContracts.length < 1">
          <div class="row border-top" *ngIf="!bLoading">
            <span class="no-content">
            {{ 'no_record_found' | translate }}
            </span>
          </div>
          <div class="row border-top" *ngIf="bLoading">
            <span class="no-content">
            <fa-icon [icon]="['fas', 'spinner']" [spin]="true" aria-hidden="true"></fa-icon>
            {{ 'loading' | translate }}
            </span>
          </div>
        </div>
        <ng-container *ngIf="isSites; else contractList">
          <ng-container [ngTemplateOutlet]="siteList"></ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</app-error-handler>

<ng-template #siteList>
  <div class="row border-top pt-2 pb-2" *ngFor="let contract of arContracts" [id]="'widgetSitesRecord' + contract.contract_id">
    <div class="col-sm-1">
      <fa-icon
        [icon]="['fas', 'circle']"
        class="icon-size"
        [ngClass]="contract.active ? 'text-success' : 'text-danger'"
        matTooltip="{{ contract.active_text | translate }}"
      ></fa-icon>
    </div>
    <div class="col-sm-9">
      <div class="text-activity-type truncate">
        <a id="widgetContractLabel" matTooltip="{{ 'contract_number' | translate }}: {{ contract.contract_text }}" class="pointer" href="/#/contracts/{{ contract.contract_id }}">
          <span>{{ contract.contract_text }}</span>
        </a>
      </div>
      <div class="text-activity-type truncate">
        <a id="contractSummary" matTooltip="{{ 'summary' | translate }}: {{ contract.contract_summary }}">
          <span>{{ contract.contract_summary }}</span>
        </a>
      </div>
    </div>
    <div class="col-sm-2">
      <div class="row">
        <div class="col-12 pl-2">
          <fa-icon id="widgetContractEdit" class="text-success pointer float-right" [icon]="['fas', 'pencil']" (click)="openForm(contract)"></fa-icon>
        </div>
        <div class="col-12 pl-2">
          <fa-icon id="widgetContractDelete" class="text-warning pointer float-right" [icon]="['fas', 'unlink']" (click)="deleteRecord(contract)"></fa-icon>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #contractList>
  <div class="row border-top pt-2 pb-2" *ngFor="let contract of arContracts" [id]="'widgetSitesRecord' + contract.id">
    <div class="col-sm-1">
      <fa-icon
        [icon]="['fas', 'circle']"
        class="icon-size"
        [ngClass]="contract.active ? 'text-success' : 'text-danger'"
        matTooltip="{{ contract.active_text | translate }}"
      ></fa-icon>
    </div>
    <div class="col-sm-9">
      <div class="text-activity-type truncate">
        <a id="widgetContractLabel" matTooltip="{{ 'contract_number' | translate }}: {{ contract.text }}" class="pointer" href="/#/contracts/{{ contract.id }}">
          <span>{{ contract.text }}</span>
        </a>
      </div>
      <div class="text-activity-type truncate">
        <a id="contractSummary" matTooltip="{{ 'summary' | translate }}: {{ contract.summary }}">
          <span>{{ contract.summary }}</span>
        </a>
      </div>
    </div>
    <div class="col-sm-2">
      <div class="row">
        <div class="col-12 pl-2">
          <fa-icon id="widgetContractEdit" class="text-success pointer float-right" [icon]="['fas', 'pencil']" (click)="openForm(contract)"></fa-icon>
        </div>
        <div class="col-12 pl-2">
          <fa-icon id="widgetContractDelete" class="text-warning pointer float-right" [icon]="['fas', 'trash-alt']" (click)="deleteRecord(contract)"></fa-icon>
        </div>
      </div>
    </div>
  </div>
</ng-template>